import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Legend } from 'recharts';

export function ExpenseBreakdown({ expenses }) {
  const fmt = (a) => `$${(a || 0).toLocaleString()}`;
  const cats = expenses.by_category || {};
  const labels = { software: 'Software', hosting: 'Hosting', api: 'API', marketing: 'Marketing', tools: 'Tools', other: 'Other' };
  const data = Object.entries(cats).map(([k, v]) => ({ name: labels[k] || k, amount: v })).sort((a, b) => b.amount - a.amount);

  if (data.length === 0) return (
    <div className="bg-white rounded-xl border border-gray-200 p-6">
      <h3 className="font-bold text-[#0A1628] mb-4">Expense Breakdown</h3>
      <p className="text-sm text-gray-400 text-center py-8">No expenses recorded</p>
    </div>
  );

  return (
    <div className="bg-white rounded-xl border border-gray-200 p-6">
      <h3 className="font-bold text-[#0A1628] mb-2">Expense Breakdown</h3>
      <p className="text-xs text-gray-400 mb-4">By category</p>
      <ResponsiveContainer width="100%" height={220}>
        <BarChart data={data} layout="vertical" margin={{ top: 0, right: 10, left: 10, bottom: 0 }}>
          <CartesianGrid strokeDasharray="3 3" stroke="#f1f5f9" horizontal={false} />
          <XAxis type="number" tick={{ fontSize: 10, fill: '#94a3b8' }} axisLine={false} tickFormatter={fmt} />
          <YAxis type="category" dataKey="name" tick={{ fontSize: 11, fill: '#64748b' }} axisLine={false} tickLine={false} width={70} />
          <Tooltip formatter={(v) => fmt(v)} contentStyle={{ borderRadius: 12, border: '1px solid #e2e8f0', fontSize: 12 }} />
          <Bar dataKey="amount" fill="#ef4444" radius={[0, 6, 6, 0]} barSize={20} />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
}
